import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

function ReportsSweepWinnerHeader(props) {
  const {
    onChangeDates,
    onClickExport,
    dates,
    sync,
    isLoading,
    children,
  } = props

  return (
    <>
      <HeaderContainerGrid title='Sweep Winner Report'>
        <HeaderActions>
          <ReportDatePicker dates={dates} onChange={onChangeDates} />
          <HeaderSeparator />
          <Button size="lg" variant='outline' onClick={onClickExport} >Export</Button>
          {children}
          <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
        </HeaderActions>
      </HeaderContainerGrid>
    </>
  )
}

ReportsSweepWinnerHeader.propTypes = {
  onClickFilter: PropTypes.func,
  onChangeDates: PropTypes.func,
  onClickExport: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.any,
}

export default ReportsSweepWinnerHeader
